module.exports = __webpack_public_path__ + "static/wailing-f5b8e9a9efd3b957fc56decc3bcf4c76.jpg";